import { Component, ElementRef, Input } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { InternalAnalyticsService } from '@shared/services/internalAnalytics.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { LinkService } from '@shared/services/link.service';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CourseViewBaseComponent } from '@shared/base-components/course-view.base.component';

@Component({
  selector: 'simulation-list-item',
  templateUrl: './simulation-list-item.component.html',
  styleUrls: ['./simulation-list-item.component.scss'],
  animations: fuseAnimations
})

export class SimulationListItemComponent extends CourseViewBaseComponent {
  @Input() simplifiedMode = false;

  constructor(
    protected _router: Router,
    protected _activatedRoute: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    protected _currentHubService: CurrentHubService,
    protected _internalAnalyticsService: InternalAnalyticsService,
    protected _linkService: LinkService,
    protected el: ElementRef,
    protected _courseApiService: CoursesAPIService,
    protected _dialog: MatDialog,
    protected _authService: AuthenticationService
  ) {
    super(_router, _activatedRoute, sanitizer, _currentHubService, _internalAnalyticsService, _linkService, el, _courseApiService, _dialog, _authService);
  }
}
